import React from "react";
import Contact from "./Contact";

// Alias de /contact conservé pour les liens existants. La page Contact pose
// elle-même l'URL canonique vers /contact : Google n'indexe donc qu'une seule
// version, sans contenu dupliqué. Cette URL est retirée du sitemap.
const ContactAMOANAH = () => {
  return <Contact />;
};

export default ContactAMOANAH;
